export default "__VITE_ASSET__cb3a6d4a__"